import { useEffect, useState } from "react";
import ExternalLink from "../../../components/externalLink/externalLink";
import ChildComponentLegacy from "../../../components/applicationComponents/legacy/child/ChildComponentLegacy";
import ApplicationFiles from "../../../components/applicationComponents/applicationFiles/ApplicationFilesComponent";
import AdminNotesComponent from "../../../components/applicationComponents/administrativeNotes/administrativeNotesComponent";
import AssignAssessorComponent from "../../../components/applicationComponents/assignAssessor/AssignAssessorComponent";
import { useApplicationContext } from "../../../components/applicationComponents/context/applicationContext";
import AssignStatusComponent from "../../../components/applicationComponents/assignStatus/AssignStatusComponent";
import GroupSupportNeedsComponent from "../../../components/applicationComponents/legacy/groupSupportNeeds/GroupSupportNeedsComponent";
import KinderProgramComponent from "../../../components/applicationComponents/kinderProgram/KinderProgramComponent";
import KindergartenComponentLegacy from "../../../components/applicationComponents/legacy/kindergarten/KindergartenComponentLegacy";
import ApplicationApprovalComponentLegacy from "../../../components/applicationComponents/legacy/applicationApproval/ApplicationApprovalComponentLegacy";
import SupportTypeComponentLegacy from "../../../components/applicationComponents/legacy/supportType/SupportTypeLegacy";
import ContextOfChildComponentLegacy from "../../../components/applicationComponents/legacy/contextOfChild/ContextOfChildComponentLegacy";
import ApplicationTypeComponentLegacy from "../../../components/applicationComponents/legacy/applicationType/ApplicationTypeComponentLegacy";
import ApplicationChecklistComponentLegacy from "../../../components/applicationComponents/legacy/applicationChecklist/ApplicationChecklistComponentLegacy";
import AppealRequestComponentLegacy from "../../../components/applicationComponents/legacy/appealRequest/appealRequestComponentLegacy";
import AppealOutcomeComponentLegacy from "../../../components/applicationComponents/legacy/appealOutcome/appealOutcomeComponentLegacy";

export default function ApplicationViewLegacy() {
  const [loaded, setLoaded] = useState(false);

  const { setHeaderText } = useApplicationContext();
  useEffect(() => {
    setHeaderText({
      value: "View Application",
      icon: "view-app-icon mr-3 mt-0",
    });
  }, []);
  const { id, applicationBase, rehydrate } = useApplicationContext();
  useEffect(() => {
    rehydrate().then(() => {
      setLoaded(true);
    });
  }, []);

  return (
    <div className="w-full">
      {loaded && (
        <div className="flex flex-column align-items-start w-full height-calc">
          <ApplicationTypeComponentLegacy disabled={true} data={applicationBase.applicationType} />
          <ChildComponentLegacy disabled={true} data={applicationBase.child} />
          <AssignStatusComponent disabled={true} data={applicationBase.assignStatus} />
          <AssignAssessorComponent disabled={true} data={applicationBase.assignAssessor ?? {}} />
          <KindergartenComponentLegacy disabled={true} data={applicationBase.kindergarten} />
          <KinderProgramComponent disabled={true} data={applicationBase.kinderProgram} />
          <ContextOfChildComponentLegacy disabled={true} data={applicationBase.contextOfChildLegacy} />
          <AdminNotesComponent disabled={true} data={applicationBase.administrativeNote} />
          <ExternalLink linkLabel="Application and Evidence Document Upload" applicationId={id} />
          <ApplicationApprovalComponentLegacy disabled={true} data={applicationBase.applicationApproval} />
          <GroupSupportNeedsComponent disabled={true} data={applicationBase.groupSupportNeeds} />
          <SupportTypeComponentLegacy disabled={true} data={applicationBase.supportType} />
          <AppealRequestComponentLegacy disabled={true} data={applicationBase.appealRequest} />
          <AppealOutcomeComponentLegacy disabled={true} data={applicationBase.appealOutcome} />
          <ApplicationFiles disabled={true} data={applicationBase.applicationFiles} />
          {applicationBase.applicationChecklistsLegacy ? (
            applicationBase.applicationChecklistsLegacy.checklistsLegacy.map((data: any, index: number) => {
              return <ApplicationChecklistComponentLegacy key={index} index={index} disabled={true} data={data} />;
            })
          ) : (
            <ApplicationChecklistComponentLegacy index={0} disabled={true} data={{}} applicationId={id} />
          )}
        </div>
      )}
    </div>
  );
}
